import { useGetDeviceType } from "_common/hooks/global";

export default function FollowUserComponent ( {
	userId,
	isLoggedIn,
	ownProfileId,
	isFollow,
	userName,
	followComponent,
	unfollowComponent,
	handleFollowUser,
	isForceShow,
	from,
	fromHomePage
} ) {
	const showFollowButton = isForceShow || !ownProfileId || ( ownProfileId && ownProfileId !== userId ) || !isLoggedIn;

	if ( !showFollowButton )
		return null;

	const isAlreadyFollowingUser = isLoggedIn && isFollow;

	const deviceType = useGetDeviceType ();

	const isMobile = deviceType === "mobile";

	const isFollowingAndMobileScreen = isMobile && isAlreadyFollowingUser;

	const renderingComponent = isAlreadyFollowingUser ? unfollowComponent : followComponent;

	// if ( isFollowingAndMobileScreen || ( showFollowButton && !isAlreadyFollowingUser ) )
	return (
		<div onClick = { handleFollowUser }
			style = { { width: from === "userInfoPopOver" ? "48%" : fromHomePage ? "100%" : "" } }
		>
			{renderingComponent}
		</div>
	);

}
